import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';
import { Helpers } from '../helpers';

@Directive({
    selector: '[appunwraptag]',
})
export class UnwrapTagDirective implements AfterViewInit {
    private el = inject(ElementRef);

    ngAfterViewInit() {
        const nativeElement: HTMLElement = this.el.nativeElement;
        Helpers.unwrapTag(nativeElement);
    }
}
